import React, { ReactElement, useEffect, useState } from 'react';
import { FileContainerStyled, FileItem } from './DetailsContent.styles';
import { Button, Tag } from 'antd';
import { DetailsCards } from '../FileDetails.styles';
import { apiPreFlights } from 'utilities/http/api/pupDocs/apiPreFlights';
import { useParams } from 'react-router-dom';
import { notify } from 'utilities/notifications/notify';
import { useDetailsState } from '../useDetailsState';
import { DetailsSubHeader } from '../detailsSubHeader/DetailsSubHeader';
import { DetailsHeader } from '../detailsHeader/DetailsHeader';
import {
  getFileTypeIcon,
  mapBreeder,
  mapCustomer,
  mapPuppy,
  renderMediaDocuments,
} from '../utilities/Details.utilities';
import date from 'utilities/dates/date';
import { LineItemMedia } from 'pupdocs/types';
import DocumentViewer from '../documentViewer/DocumentViewer';
import { CardTabs } from 'shared/components/cards/CardsTabs';

interface RouteParameters {
  lineItemId: string;
}

export function DetailsContent(): ReactElement | null {
  const [viewerVisible, setViewerVisible] = useState(false);
  const { lineItemId }: RouteParameters = useParams();
  const {
    state: { lineItem },
    dispatch,
  } = useDetailsState();

  const handleReview = () => {
    setViewerVisible(!viewerVisible);
  };

  const renderFileItem = (media: LineItemMedia): ReactElement => {
    return (
      <FileContainerStyled key={media.id}>
        <FileItem>
          {getFileTypeIcon(media.name)}
          <span>{media.name}</span>
        </FileItem>
        <FileItem>{renderMediaDocuments(media)}</FileItem>
        <FileItem>
          <span>Uploaded: {date.toUSLocale(media.uploadedAt)}</span>
        </FileItem>

        <FileItem>
          <Tag color="orange">In review</Tag>
          <span>
            by <strong>Username</strong>
          </span>
          <Button type="link" block>
            Release
          </Button>
        </FileItem>
        <FileItem>
          <Button type="primary" onClick={handleReview}>
            Review
          </Button>
        </FileItem>
      </FileContainerStyled>
    );
  };

  const fetchPackage = async () => {
    try {
      const response = await apiPreFlights.getById(lineItemId);
      if (response.isOk) {
        dispatch({ type: 'SET_LINE_ITEM', lineItem: response.json.lineItem });
      }
    } catch (e) {
      notify.error(`Couldn't fetch puppy documents with id: ${lineItemId}`);
    }
  };

  const onCloseViewer = () => {
    setViewerVisible(false);
  };

  useEffect(() => {
    fetchPackage();
  }, []);

  const mappedPuppy = mapPuppy(lineItem);

  if (lineItem) {
    return (
      <>
        <DetailsHeader
          puppyId={lineItem.puppy.id}
          travelMethod={lineItem.travelMethod.name}
          meta={lineItem.meta}
        />
        <DetailsSubHeader
          meta={lineItem.meta}
          media={lineItem.media ? lineItem.media[0] : null}
        />
        {lineItem.media.map((item: LineItemMedia) => renderFileItem(item))}
        <DetailsCards>
          <CardTabs
            puppy={{ puppy: mappedPuppy, soldDate: mappedPuppy.soldDate }}
            customer={{
              titlePrefix: 'Contact',
              person: mapCustomer(lineItem),
            }}
            breeder={{
              titlePrefix: 'Breeder',
              person: mapBreeder(lineItem),
            }}
          />
        </DetailsCards>
        <DocumentViewer visible={viewerVisible} onClose={onCloseViewer} />
      </>
    );
  }

  return null;
}
